import { API_URL } from '../../../../utils/config';

export const GET_EXTENSIONS_URL = `${API_URL}/geniatechlog/get_extension_logs/1`;
export const PAGINATE_EXTENSIONS_URL = `${API_URL}/geniatechlog/get_extension_logs`;
export const EXTEND_CUSTOMER_URL = `${API_URL}/geniatech/extenduser`;
export const LOG_EXTENSION_URL = `${API_URL}/geniatechlog/addlog`;
